<template lang="html">
  <div class="full-page">
    <i-header title="投资者基本信息" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <div class="product-questions">
        <div class="product-questions-form">
          <div class="product-questions-form-item">
            <div class="product-questions-form-item-title">
              一、是否为下列产品?<br/>
              为《证券期货投资者适当性管理办法》第八条第（一）款机构面向投资者发行的证券公司资产管理产品、
              基金管理公司及其子公司产品、期货公司资产管理产品、银行理财产品、保险产品、信托产品、经行业协
              会备案的私募基金，及第（一）款规定机构发行的其它理财产品；或者为第（三）款规定的社会保障基金、
              企业年金等养老基金、慈善基金等社会公益基金
            </div>
            <div class="product-questions-form-item-content">
              <cube-radio-group
                v-model="Model.isFollowProductChecked"
                :options="[
                  {label: '是', value: '是', disabled: true},
                  {label: '否', value: '否', disabled: true}
                ]"
                :horizontal="true">
              </cube-radio-group>
            </div>
          </div>

          <div class="product-questions-form-item">
            <div class="product-questions-form-item-title">
              二、机构资产规模？<br/>
              私募基金或者资产管理计划投资者，成立规模不得低于（含）人民币1000万元
            </div>
            <div class="product-questions-form-item-content">
              <cube-radio-group
                v-model="Model.orgAssetSizeChecked"
                :options="[
                  {label: '是', value: '是', disabled: true},
                  {label: '否', value: '否', disabled: true}
                ]" :horizontal="true">
              </cube-radio-group>
            </div>

          </div>

          <div class="product-questions-form-item">
            <div class="product-questions-form-item-title">
              三、是否存在实际控制关系？
            </div>
            <div class="product-questions-form-item-content">
              <cube-radio-group
                v-model="Model.isControllingShareholderChecked"
                :options="[
                  {label: '是', value: '是', disabled: true},
                  {label: '否', value: '否', disabled: true}
                ]" :horizontal="true">
              </cube-radio-group>
              <div class="natural-questions-form-item-content-desc">
                {{Model.isControllingShareholderDescription}}
              </div>
            </div>
          </div>

          <div class="product-questions-form-item">
            <div class="product-questions-form-item-title">
              四、交易实际受益人？
            </div>
            <div class="product-questions-form-item-content">
              <cube-radio-group
                v-model="Model.transactionActualBeneficiaryChecked"
                :options="[
                  {label: '本机构', value: '本机构', disabled: true},
                  {label: '其他机构或个人', value: '其他机构或个人', disabled: true}
                ]" :horizontal="true">
              </cube-radio-group>
              <div class="natural-questions-form-item-content-desc">
                {{Model.transactionActualBeneficiaryDescription}}
              </div>
            </div>

          </div>

          <div class="product-questions-form-item">
            <div class="product-questions-form-item-title">
              五、是否有不良诚信记录？
            </div>
            <div class="product-questions-form-item-content">
              <cube-radio-group
                v-model="Model.isBadFaithChecked"
                :options="[
                  {label: '是', value: '是', disabled: true},
                  {label: '否', value: '否', disabled: true}
                ]" :horizontal="true">
              </cube-radio-group>
              <div class="natural-questions-form-item-content-desc">
                {{Model.isBadFaithDescription}}
              </div>
            </div>

          </div>
        </div>

        <div class="foot-btn">
          <cube-button @click="$_handleValidate">确认</cube-button>
        </div>

      </div>
    </i-body>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getInvestorProductInfo } from '@/api/investor';
import cmixin from '../../commonConfig';

export default {
  mixins: [cmixin],
  data() {
    return {
      Model: {
        isFollowProductChecked: null,
        orgAssetSizeChecked: null,
        isControllingShareholderChecked: null,
        isControllingShareholderDescription: '',
        transactionActualBeneficiaryChecked: null,
        transactionActualBeneficiaryDescription: '',
        isBadFaithChecked: null,
        isBadFaithDescription: '',
      },
    };
  },
  computed: {
    ...mapGetters(['managerInfo', 'au']),
  },
  mounted() {
    this.$_handlerInit();
  },
  methods: {
    $_handlerInit() {
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      getInvestorProductInfo({
        productDealId: this.managerInfo.productDealId,
      }, this.au).then((res) => {
        toast.hide();
        if (res.code === 0) {
          Object.keys(this.Model).forEach((key) => {
            this.Model[key] = res.data.bean[key];
          });
          this.$store.dispatch('changeProductInfo', this.Model);
        } else {
          this.$createToast({
            txt: res.msg,
            type: 'txt',
            mask: true,
            time: 2000,
          }).show();
        }
      });
    },
    $_handleValidate() {
      this.$_headerLeftClick();
    },
  },
};
</script>

<style lang="scss" scoped>
.product-questions {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .product-questions-form {
    .product-questions-form-item {
      padding: 16px;
      background: #fff;
      margin-bottom: 10px;
      .product-questions-form-item-title {
        font-size: 12px;
        margin-bottom: 8px;
        color: #666;
        line-height: 18px;
      }
      .product-questions-form-item-content {
        .cube-validator-msg-custom {
          font-size: 12px;
          color: red;
          margin-top: 5px;
        }
      }

    }
  }
}
</style>
